<template>
  <div
    id="Notification"
    @click="handleClick"
    :class="{ new: notification.readAt === null }"
    class="mx-auto p-3"
  >
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <div v-if="dateAndTime" class="date">{{ dateAndTime }}</div>
    <div v-if="body" class="body">{{ body }}</div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: ["notification"],
  computed: {
    type() {
      if (this.notification.event.hasOwnProperty("digital_gym"))
        return "digital_gym";
      if (this.notification.event.hasOwnProperty("wellbeing_studio"))
        return "wellbeing_studio";
      if (this.notification.event.hasOwnProperty("coaching_booking"))
        return "coaching_booking";
      if (
        this.notification.event.hasOwnProperty("unread_message_from_coaching")
      )
        return "coaching_message";
      if (this.notification.event.hasOwnProperty("digital_clinics"))
        return "digital_clinics";
      return "";
    },
    body() {
      if (this.notification?.body) return this.notification.body;
      if (this.type && this.type === "coaching_message")
        return (
          "Message from " +
          this.notification?.event?.unread_message_from_coaching?.coach_identity
        );
      return null;
    },
    title() {
      if (this.notification?.subject) {
        return this.notification.subject;
      }
      if (this.type && this.type === "coaching_booking")
        return "Coaching Appointment";
      if (this.type && this.type === "coaching_message")
        return "Coaching Message";
      return this.notification?.event[this.type]?.title || null;
    },
    dateAndTime() {
      const startDate = this.notification?.event?.startDateTime || null;
      if (startDate) {
        return (
          this.getDateWithoutYear(startDate) +
          " " +
          this.getHoursMinutes(startDate)
        );
      }
      return null;
    }
  },
  methods: {
    handleClick() {
      const httpsRegex = /(https:\/\/[^\s]+)/g;
      const matches = this.notification?.body.match(httpsRegex);
      if (matches && matches.length > 0) {
        window.open(matches[0], "_blank");
      }
    }
  }
};
</script>

<style lang="less">
#Notification {
  width: 100%;
  color: #000000;
  border: 1px solid #d7d7d7;
  border-radius: 10px;
  background: #efefef;
  cursor: pointer;
  padding: 4px;
  .date {
    color: #adabab;
    font-size: 1.3rem;
  }
  .title {
    font-family: FilsonProBold, Arial, Helvetica, sans-serif;
    color: #000000;
    margin-bottom: 5px;
    font-size: 1.8rem;
  }
  .body {
    white-space: pre-wrap;
    color: #000000;
    font-size: 1.4rem;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
  }
}
</style>
